var map = {
	"./email1.png": 661,
	"./email2.png": 662,
	"./email3.png": 663,
	"./index1.png": 664,
	"./index2.png": 665,
	"./index3.png": 666,
	"./index4.png": 667,
	"./whatsApp1.png": 668,
	"./whatsApp2.png": 669,
	"./whatsApp3.png": 670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1085;